import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
export function ForgotPasswordPage() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5569">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5570">
        <div className="flex flex-col items-center mb-8" data-id="element-5571">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5572">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5573">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5574"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5575">
            Reset your password
          </h1>
          <p className="text-textMuted text-sm text-center" data-id="element-5576">
            Enter your email and we'll send you a link to reset your password.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl p-6 shadow-xl" data-id="element-5577">
          {status === 'success' ? <div className="text-center py-4" data-id="element-5578">
              <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-4" data-id="element-5579">
                <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-5580" />
              </div>
              <h3 className="text-lg font-semibold mb-2" data-id="element-5581">Check your email</h3>
              <p className="text-sm text-textMuted mb-6" data-id="element-5582">
                We've sent password reset instructions to your email address.
              </p>
              <Link to="/login" className="w-full block py-2.5 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-5583">
                Return to login
              </Link>
            </div> : <form className="space-y-6" onSubmit={e => {
          e.preventDefault();
          setStatus('success');
        }} data-id="element-5584">
              {status === 'error' && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-lg" data-id="element-5585">
                  <p className="text-sm text-red-500" data-id="element-5586">
                    We couldn't find an account with that email address.
                  </p>
                </div>}

              <div data-id="element-5587">
                <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5588">
                  Email
                </label>
                <div className="relative" data-id="element-5589">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-5590" />
                  <input type="email" className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="you@example.com" required data-id="element-5591" />
                </div>
              </div>

              <button className="w-full py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5592">
                Send reset link
              </button>
            </form>}
        </div>

        <div className="mt-6 text-center" data-id="element-5593">
          <Link to="/login" className="inline-flex items-center gap-2 text-sm text-textMuted hover:text-textMain transition-colors" data-id="element-5594">
            <ArrowLeft className="w-4 h-4" data-id="element-5595" />
            Back to login
          </Link>
        </div>
      </motion.div>
    </div>;
}